// Setup › Finance (M5-04; core, managers): finance access (`/setup/finance`: who is a finance
// admin or a seat's pay viewer; the owner grants), prices, FX rates, compensation, recurring
// costs, clients and revenue, and categories (the chart of accounts). features/finance.
import { createRoute, useRouteContext } from "@tanstack/react-router";
import { FinanceAccessScreen } from "../features/finance/access-screen";
import { CategoriesScreen } from "../features/finance/categories-screen";
import { ClientsScreen } from "../features/finance/clients-screen";
import { CompensationScreen } from "../features/finance/compensation-screen";
import { ExpensesScreen } from "../features/finance/expenses-screen";
import { FxScreen } from "../features/finance/fx-screen";
import { PricesScreen } from "../features/finance/prices-screen";
import { useCompany } from "../features/use-feature";
import { setupRoute } from "./c.$slug.setup";

const page = <P extends string>(path: P, Screen: typeof FinanceAccessScreen) =>
  createRoute({
    getParentRoute: () => setupRoute,
    path,
    component: function SetupFinancePage() {
      const { api } = useRouteContext({ from: "__root__" });
      return <Screen api={api} company={useCompany()} />;
    },
  });

export const setupFinanceRoutes = [
  page("finance", FinanceAccessScreen),
  page("finance/prices", PricesScreen),
  page("finance/fx", FxScreen),
  page("finance/compensation", CompensationScreen),
  page("finance/expenses", ExpensesScreen),
  page("finance/clients", ClientsScreen),
  page("finance/categories", CategoriesScreen),
] as const;
